import i18n from "i18next";

import { initReactI18next } from "react-i18next";

// eager: all locale files are small and were already bundled wholesale under
// webpack's require() context; import.meta.glob is the Vite equivalent.
const localeModules = import.meta.glob("/language/locales/*/*.json", {
  eager: true,
});

const LocalFileBackend = {
  type: "backend",
  init() {},
  read(language, namespace, callback) {
    const mod =
      localeModules[`/language/locales/${language}/${namespace}.json`];
    if (mod) {
      callback(null, mod.default ?? mod);
    } else {
      callback(
        new Error(`Missing locale file for ${language}/${namespace}`),
        null,
      );
    }
  },
};

// Dirty fix - remove "currentLanguage" from localStorage if cookie "languageId" doesn't exist.
if (document.cookie.indexOf("languageId") < 0) {
  localStorage.removeItem("currentLanguage");
}

i18n
  .use(LocalFileBackend)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    //debug: true,
    lng: localStorage.getItem("currentLanguage") || "de",
    fallbackLng: "en",
    //preload: ['de', 'en'],

    ns: ["language"],
    defaultNS: "language",

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    keySeparator: false,
    joinArrays: false,
    returnObjects: false,

    // react i18next special options (optional)
    react: {
      useSuspense: true,
      nsMode: "default", // set it to fallback to let passed namespaces to translated hoc act as fallbacks
    },
  });

export { i18n };
